import { useExtractMetadataFromSearchQuerySearchCardValue } from '@aibees/elephant/feature/search-list-card/hooks/use-extract-metadata-from-search-query-search-card-value';
import { useSearchListCardStore } from '@aibees/elephant/feature/search-list-card/store';
import { IconButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils/class-names';
import { Stack } from '@mui/material';
import { memo, useCallback } from 'react';
import type { SaveSearchTableActionProps as Props } from './types';

export const SaveSearchTableAction = memo(({ className, item }: Props) => {
  const { setState } = useSearchListCardStore();
  const { metadata, path } =
    useExtractMetadataFromSearchQuerySearchCardValue(item);

  const handleViewClick = useCallback(() => {
    setState(true);
    if (path) window.open(path, '_blank');
  }, [setState, path]);

  if (!metadata?.url) return null;

  return (
    <Stack
      className={classnames('SaveSearchTableAction', className)}
      direction="row"
      alignItems="center"
      justifyContent="center"
    >
      <IconButton
        icon="eye-outlined"
        variant="outlined"
        size="xsmall"
        onClick={handleViewClick}
      />
    </Stack>
  );
});

SaveSearchTableAction.displayName = 'SaveSearchTableAction';
